import { useUserCompany } from "../../features/User/userQueries";
import logo from "../../components/Asset/mashoorah-logo-art-dark.svg";

export const Logo = () => {
  const { data: company } = useUserCompany({
    useErrorBoundary: false
  });
  return (
    <>
      {(!company || company.dark_color === "" || !company.dark_color) && (
        <>
          <div className="">
            <img src={logo} alt="Mashoorah logo" className="max-h-14 m-auto mb-12" />
          </div>
        </>
      )}

      {company && company.dark_color !== "" && (
        <img
          src={company.logo}
          className="object-contain w-auto max-h-full"
          alt=""
        />
      )}
    </>
  );
};
